import type { CopilotStatefulToolCall } from '@customerio/hydra-copilot';

// Single source of decision statuses so the readers can't drift.
export function capabilityStatuses(response: CopilotStatefulToolCall['response']): string[] {
  const raw = response?.result;
  if (raw == null) return [];
  const items: unknown[] = Array.isArray(raw) ? raw : [raw];
  const statuses: string[] = [];
  for (const item of items) {
    if (item == null || typeof item !== 'object') continue;
    const result = item as Record<string, unknown>;
    if ('stdout' in result || 'exit_code' in result) continue;
    if (typeof result.status === 'string') statuses.push(result.status);
  }
  return statuses;
}
